export default __webpack_public_path__ + "static/media/runnerup_5.a09a9014.jpg";